/* Secalma · JS compartido */
(function () {
  'use strict';
  var TZ = 'Europe/Madrid';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var cur = (window.Shopify && Shopify.currency && Shopify.currency.active) || 'EUR';
  function money(cents) {
    try { return new Intl.NumberFormat('es-ES', { style: 'currency', currency: cur }).format(cents / 100); }
    catch (e) { return (cents / 100).toFixed(2).replace('.', ',') + ' €'; }
  }
  function store(k, v) { try { if (v === undefined) return localStorage.getItem(k); localStorage.setItem(k, v); } catch (e) { return null; } }

  /* ---------- Cuenta atrás real hasta medianoche (Madrid) ---------- */
  function secsToMidnight() {
    var p = new Intl.DateTimeFormat('en-GB', { timeZone: TZ, hour: '2-digit', minute: '2-digit', second: '2-digit', hour12: false }).formatToParts(new Date());
    var g = function (t) { return +p.filter(function (x) { return x.type === t; })[0].value; };
    return 86400 - ((g('hour') % 24) * 3600 + g('minute') * 60 + g('second'));
  }
  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function tickMidnight() {
    var s = secsToMidnight(), h = Math.floor(s / 3600), m = Math.floor((s % 3600) / 60), x = s % 60;
    $$('[data-sc-midnight]').forEach(function (el) {
      if (el.dataset.scMidnight === 'text') el.textContent = pad(h) + ':' + pad(m) + ':' + pad(x);
      else el.innerHTML = '<span>' + pad(h) + '</span><span>' + pad(m) + '</span><span>' + pad(x) + '</span>';
    });
  }

  /* ---------- Fecha estimada de entrega (días hábiles) ---------- */
  function addBusinessDays(d, n) { var r = new Date(d); while (n > 0) { r.setDate(r.getDate() + 1); var w = r.getDay(); if (w !== 0 && w !== 6) n--; } return r; }
  function fmtDate(d) { return new Intl.DateTimeFormat('es-ES', { weekday: 'short', day: 'numeric', month: 'short', timeZone: TZ }).format(d).replace('.', ''); }
  function initEta() {
    $$('[data-sc-eta]').forEach(function (el) {
      var a = +el.dataset.min || 10, b = +el.dataset.max || 15, now = new Date();
      el.textContent = 'entre el ' + fmtDate(addBusinessDays(now, a)) + ' y el ' + fmtDate(addBusinessDays(now, b));
    });
  }

  /* ---------- Slideshow (hero) ---------- */
  function initSliders() {
    $$('[data-sc-slider]').forEach(function (root) {
      var track = $('[data-sc-track]', root), slides = Array.prototype.slice.call(track.children), dots = $('[data-sc-dots]', root);
      if (slides.length < 2) { if (dots) dots.remove(); return; }
      var idx = 0, user = false;
      slides.forEach(function (_, i) {
        var b = document.createElement('button'); b.type = 'button'; b.setAttribute('aria-label', 'Diapositiva ' + (i + 1));
        b.addEventListener('click', function () { user = true; go(i); }); dots.appendChild(b);
      });
      function paint() { $$('button', dots).forEach(function (b, i) { b.setAttribute('aria-current', i === idx ? 'true' : 'false'); }); }
      function go(i) { idx = (i + slides.length) % slides.length; track.scrollTo({ left: track.clientWidth * idx, behavior: 'smooth' }); paint(); }
      track.addEventListener('scroll', function () { var i = Math.round(track.scrollLeft / track.clientWidth); if (i !== idx) { idx = i; paint(); } }, { passive: true });
      track.addEventListener('pointerdown', function () { user = true; });
      paint();
      var ms = +(root.dataset.autoplay || 0);
      if (ms) setInterval(function () { if (!user && !document.hidden) go(idx + 1); }, ms);
    });
  }

  /* ---------- Carruseles con flechas + puntos de las tarjetas ---------- */
  function initRails() {
    $$('[data-sc-rail-nav]').forEach(function (nav) {
      var rail = document.getElementById(nav.dataset.scRailNav); if (!rail) return;
      $$('button', nav).forEach(function (b) {
        b.addEventListener('click', function () { rail.scrollBy({ left: (b.dataset.dir === 'prev' ? -1 : 1) * rail.clientWidth * 0.8, behavior: 'smooth' }); });
      });
      if (rail.scrollWidth <= rail.clientWidth + 4) nav.style.display = 'none';
    });
    $$('.sc-card__imgs').forEach(function (t) {
      var pips = t.parentNode.querySelector('.sc-card__pips'); if (!pips) return;
      var n = t.children.length; if (n < 2) { pips.remove(); return; }
      pips.innerHTML = new Array(n + 1).join('<i></i>');
      var paint = function () { var i = Math.round(t.scrollLeft / t.clientWidth); $$('i', pips).forEach(function (p, j) { p.style.background = j === i ? '#fff' : 'rgba(255,255,255,.55)'; p.style.transform = j === i ? 'scale(1.3)' : ''; }); };
      t.addEventListener('scroll', paint, { passive: true }); paint();
    });
  }

  /* ---------- Modales ---------- */
  function openModal(id) { var m = document.getElementById(id); if (m) { m.classList.add('is-open'); document.documentElement.style.overflow = 'hidden'; } }
  function closeModal(m) { m.classList.remove('is-open'); document.documentElement.style.overflow = ''; if (m.dataset.scPopup !== undefined) store('sc_pop_snooze', String(Date.now())); }
  function initModals() {
    document.addEventListener('click', function (e) {
      var o = e.target.closest('[data-sc-open]'); if (o) { e.preventDefault(); openModal(o.dataset.scOpen); return; }
      var c = e.target.closest('[data-sc-close]'); if (c) { closeModal(c.closest('.sc-modal')); return; }
      if (e.target.classList && e.target.classList.contains('sc-modal')) closeModal(e.target);
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape') $$('.sc-modal.is-open').forEach(closeModal); });
  }

  /* ---------- Pop-up de la guía gratis ---------- */
  function initPopup() {
    var pop = $('[data-sc-popup]'); if (!pop) return;
    var posted = /customer_posted=true/.test(location.search) || /#sc-pop-ok/.test(location.hash);
    if (posted) { pop.classList.add('is-done'); openModal(pop.id); store('sc_pop_snooze', String(Date.now() + 1e12)); return; }
    if (/\/cart/.test(location.pathname)) return;
    var last = +(store('sc_pop_snooze') || 0); if (Date.now() - last < 7 * 864e5) return;
    var shown = false;
    var show = function () { if (shown || $('.sc-modal.is-open')) return; shown = true; openModal(pop.id); };
    setTimeout(show, (+pop.dataset.delay || 20) * 1000);
    window.addEventListener('scroll', function () { var h = document.documentElement; if ((h.scrollTop + innerHeight) / h.scrollHeight > 0.55) show(); }, { passive: true });
    if (matchMedia('(pointer:fine)').matches) document.addEventListener('mouseout', function (e) { if (!e.relatedTarget && e.clientY < 8) show(); });
  }

  /* ---------- Calculadora de ahorro ---------- */
  function initCalc() {
    $$('[data-sc-calc]').forEach(function (root) {
      var n = $('[name=n]', root), p = $('[name=p]', root);
      var paint = function () {
        $('[data-out-n]', root).textContent = n.value + (n.value === '1' ? ' al día' : ' al día');
        $('[data-out-p]', root).textContent = money(Math.round(p.value * 100));
        $('[data-out-year]', root).textContent = money(Math.round(n.value * p.value * 365 * 100));
      };
      n.addEventListener('input', paint); p.addEventListener('input', paint); paint();
    });
  }

  /* ---------- Ficha de producto ---------- */
  var SW = { gris: '#9b9a9f', rosa: '#f1b6c5', 'rojo coral': '#e2654e', coral: '#f2c4a4', rojo: '#c23b3b', negro: '#232023', beige: '#e7d2b8', piel: '#e8c6a8', blanco: '#fff', azul: '#7fa6d6' };
  function swatchFor(v, all) {
    var k = v.toLowerCase();
    if (k.indexOf('surtido') === 0) {
      var cols = surtidoColors(v, all).map(function (c) { return SW[c.toLowerCase()] || '#ccc'; });
      var step = 360 / cols.length, stops = cols.map(function (c, i) { return c + ' ' + (i * step) + 'deg ' + ((i + 1) * step) + 'deg'; });
      return 'conic-gradient(' + stops.join(',') + ')';
    }
    return SW[k] || '#ccc';
  }
  function surtidoColors(v, all) {
    var m = v.match(/\(([^)]+)\)/);
    if (m && !/de cada/i.test(m[1])) return m[1].split(/,| y /).map(function (s) { return s.trim(); }).filter(Boolean);
    return all.filter(function (c) { return c.toLowerCase().indexOf('surtido') !== 0; });
  }
  function units(pack) { var m = String(pack).match(/\d+/); return m ? +m[0] : 1; }
  function plural(c, n) { c = c.toLowerCase(); return n > 1 ? c : c; }

  function initPdp() {
    $$('[data-sc-pdp]').forEach(function (root) {
      var data = JSON.parse($('[data-sc-product]', root).textContent);
      var names = data.options.map(function (o) { return (o.name || o).toLowerCase(); });
      var iP = names.findIndex(function (n) { return /pack|cantidad|quantity/.test(n); });
      var iS = names.findIndex(function (n) { return /talla|size/.test(n); });
      var iC = names.findIndex(function (n) { return /color|colour/.test(n); });
      var V = data.variants;
      var vals = function (i) { var o = []; V.forEach(function (v) { var x = v.options[i]; if (o.indexOf(x) < 0) o.push(x); }); return o; };
      var packs = iP > -1 ? vals(iP).sort(function (a, b) { return units(a) - units(b); }) : [null];
      var sizes = iS > -1 ? vals(iS) : [null];
      var colors = iC > -1 ? vals(iC).sort(function (a, b) { return (b.toLowerCase().indexOf('surtido') === 0) - (a.toLowerCase().indexOf('surtido') === 0); }) : [null];
      var find = function (p, s, c) {
        return V.filter(function (v) {
          return (iP < 0 || p == null || v.options[iP] === p) && (iS < 0 || s == null || v.options[iS] === s) && (iC < 0 || c == null || v.options[iC] === c);
        });
      };
      var st = { p: null, s: null, c: null };
      // Estado inicial: variante de la URL o pack por defecto (el del medio)
      var urlV = +(new URLSearchParams(location.search).get('variant') || 0), uv = V.filter(function (v) { return v.id === urlV; })[0];
      if (uv) { st.p = iP > -1 ? uv.options[iP] : null; st.s = iS > -1 ? uv.options[iS] : null; st.c = iC > -1 ? uv.options[iC] : null; st.cu = true; }
      else {
        var qp = new URLSearchParams(location.search).get('pack');
        var dp = packs.indexOf(qp) > -1 ? qp : root.dataset.defaultPack;
        st.p = packs.indexOf(dp) > -1 ? dp : packs[packs.length === 3 ? 1 : 0];
        st.s = sizes.length === 1 ? sizes[0] : null;
        st.c = colors.filter(function (c) { return find(st.p, null, c).length; })[0] || colors[0];
      }

      var elPacks = $('[data-packs]', root), elSizes = $('[data-sizes]', root), elColors = $('[data-colors]', root);
      var badges = packs.length === 3 ? ['', 'Más vendido', 'Máximo ahorro'] : packs.length === 2 ? ['', 'Más ahorro'] : [''];

      if (elPacks && iP > -1) packs.forEach(function (p, i) {
        var b = document.createElement('button'); b.type = 'button'; b.className = 'sc-pack'; b.setAttribute('role', 'radio'); b.dataset.v = p;
        b.innerHTML = (badges[i] ? '<span class="sc-pack__tag' + (i === 2 ? ' sc-pack__tag--dark' : '') + '">' + badges[i] + '</span>' : '') +
          '<span class="sc-pack__radio"></span><span><span class="sc-pack__t">' + units(p) + ' bragas</span><span class="sc-pack__s" data-sub></span></span>' +
          '<span class="sc-pack__p"><b data-pr></b><s data-cp></s></span>';
        b.addEventListener('click', function () { st.p = p; fix(); paint(); });
        elPacks.appendChild(b);
      });
      if (elSizes && iS > -1) sizes.forEach(function (s) {
        var b = document.createElement('button'); b.type = 'button'; b.className = 'sc-size'; b.setAttribute('role', 'radio'); b.dataset.v = s; b.textContent = s;
        b.addEventListener('click', function () { st.s = s; $('[data-opt-size]', root).classList.remove('is-error'); fix(); paint(); });
        elSizes.appendChild(b);
      });
      if (elColors && iC > -1) colors.forEach(function (c) {
        var b = document.createElement('button'); b.type = 'button'; b.className = 'sc-color'; b.setAttribute('role', 'radio'); b.dataset.v = c;
        var label = c.toLowerCase().indexOf('surtido') === 0 ? 'Surtido' : c;
        b.innerHTML = '<i style="background:' + swatchFor(c, colors) + '"></i>' + label;
        b.addEventListener('click', function () { st.c = c; st.cu = true; fix(); paint(); });
        elColors.appendChild(b);
      });
      if (iC > -1 && colors.length < 2 && elColors) elColors.closest('.sc-opt').style.display = 'none';

      function fix() {
        if (st.s && !find(st.p, st.s, null).length) st.s = null;
        if (!st.cu) { var sur = colors.filter(function (c) { return c.toLowerCase().indexOf('surtido') === 0 && find(st.p, st.s, c).length; })[0]; if (sur) st.c = sur; }
        if (!find(st.p, st.s, st.c).length) {
          var ok = colors.filter(function (c) { return find(st.p, st.s, c).length; });
          st.c = ok[0] || st.c;
        }
      }
      function current() { return find(st.p, st.s, st.c)[0] || find(st.p, null, st.c)[0] || find(st.p, null, null)[0] || V[0]; }

      function paint() {
        var v = current(), full = !!(find(st.p, st.s, st.c).length && (iS < 0 || st.s));
        var n = units(st.p), save = v.compare_at_price > v.price ? Math.round((1 - v.price / v.compare_at_price) * 100) : 0;
        // Packs
        $$('.sc-pack', root).forEach(function (b) {
          var pv = find(b.dataset.v, st.s, null)[0] || find(b.dataset.v, null, null)[0];
          var u = units(b.dataset.v), sv = pv.compare_at_price > pv.price ? Math.round((1 - pv.price / pv.compare_at_price) * 100) : 0;
          b.setAttribute('aria-checked', b.dataset.v === st.p ? 'true' : 'false');
          $('[data-pr]', b).textContent = money(pv.price);
          $('[data-cp]', b).textContent = pv.compare_at_price > pv.price ? money(pv.compare_at_price) : '';
          $('[data-sub]', b).innerHTML = money(Math.round(pv.price / u)) + ' / braga' + (sv ? ' · <b>Ahorras ' + sv + ' %</b>' : '');
        });
        $$('.sc-size', root).forEach(function (b) {
          b.setAttribute('aria-checked', b.dataset.v === st.s ? 'true' : 'false');
          b.disabled = !find(st.p, b.dataset.v, null).length;
        });
        $$('.sc-color', root).forEach(function (b) {
          b.setAttribute('aria-checked', b.dataset.v === st.c ? 'true' : 'false');
          b.disabled = !find(st.p, st.s, b.dataset.v).length;
        });
        var lbl = function (k, t) { var e = $('[data-label-' + k + ']', root); if (e) e.textContent = t || ''; };
        lbl('pack', st.p ? n + ' bragas' : '');
        lbl('size', st.s || 'elige tu talla');
        lbl('color', st.c);
        // Precio
        $$('[data-price]', root.ownerDocument).forEach(function (e) { e.textContent = money(v.price); });
        $$('[data-compare]', root).forEach(function (e) { e.textContent = v.compare_at_price > v.price ? money(v.compare_at_price) : ''; });
        $$('[data-save]', root).forEach(function (e) { e.textContent = save ? 'Ahorras ' + money(v.compare_at_price - v.price) : ''; e.style.display = save ? '' : 'none'; });
        $$('[data-unit]', root).forEach(function (e) { e.textContent = money(Math.round(v.price / n)); });
        // Qué incluye el pack
        var promo = $('[data-promo]', root);
        if (promo && st.c) {
          var txt;
          if (st.c.toLowerCase().indexOf('surtido') === 0) {
            var cs = surtidoColors(st.c, colors), cnt = cs.map(function () { return 0; });
            for (var i = 0; i < n; i++) cnt[i % cs.length]++;
            var parts = cs.map(function (c, i) { return cnt[i] + ' ' + c.toLowerCase(); }).filter(function (x) { return x[0] !== '0'; });
            txt = parts.length > 1 ? parts.slice(0, -1).join(', ') + ' y ' + parts[parts.length - 1] : parts[0];
          } else txt = n + ' bragas en color ' + st.c.toLowerCase();
          promo.innerHTML = '<b>Tu pack incluye ' + n + ' bragas:</b> ' + txt + '.';
        }
        // Formulario
        var input = $('[data-variant-input]', root); if (input) input.value = v.id;
        var atc = $$('[data-atc-label]', root.ownerDocument);
        atc.forEach(function (e) { e.textContent = full ? 'Añadir al carrito · ' + money(v.price) : 'Elige tu talla'; });
        $$('[data-atc-short]', root.ownerDocument).forEach(function (e) { e.textContent = full ? 'Añadir al carrito' : 'Elegir talla'; });
        if (full && history.replaceState) { var u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u.toString()); }
        root.dataset.ready = full ? '1' : '0';
      }
      fix(); paint();

      // Bloquear añadir sin talla
      $$('[data-atc]', root.ownerDocument).forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          if (root.dataset.ready === '1') {
            if (btn.dataset.atc === 'sticky') { e.preventDefault(); $('[data-atc="main"]', root).click(); }
            return;
          }
          e.preventDefault(); e.stopPropagation();
          var o = $('[data-opt-size]', root); o.classList.remove('is-error'); void o.offsetWidth; o.classList.add('is-error');
          o.scrollIntoView({ behavior: 'smooth', block: 'center' });
        });
      });
      $$('.sc-js-hide', root).forEach(function (e) { e.style.display = 'none'; });

      // Galería
      var track = $('[data-gal-track]', root), thumbs = $$('[data-gal-thumb]', root), count = $('[data-gal-count]', root);
      if (track) {
        var sync = function () { var i = Math.round(track.scrollLeft / track.clientWidth); thumbs.forEach(function (t, j) { t.setAttribute('aria-current', i === j ? 'true' : 'false'); }); if (count) count.textContent = (i + 1) + ' / ' + track.children.length; };
        thumbs.forEach(function (t, j) { t.addEventListener('click', function () { track.scrollTo({ left: track.clientWidth * j, behavior: 'smooth' }); }); });
        track.addEventListener('scroll', sync, { passive: true }); sync();
      }
      // Barra fija
      var sticky = $('[data-sc-sticky]'), main = $('[data-atc="main"]', root);
      if (sticky && main && 'IntersectionObserver' in window) {
        new IntersectionObserver(function (en) { var r = en[0]; sticky.classList.toggle('is-on', !r.isIntersecting && r.boundingClientRect.top < 0); }).observe(main);
      }
    });
  }

  /* ---------- Carrito lateral en español + garantías ---------- */
  function enhanceCart() {
    var d = $('cart-drawer'); if (!d) return;
    var h = $('.custom-header h2', d); if (h && /cart/i.test(h.textContent)) h.textContent = 'Tu carrito';
    $$('.totals__total-value strong', d).forEach(function (s) { if (/Save/.test(s.textContent)) s.textContent = s.textContent.replace('Save', 'Ahorras'); });
    var ctas = $('.cart__ctas', d);
    var tx = document.getElementById('sc-cart-extras');
    if (tx && ctas && !$('.sc-cartx', d)) { ctas.parentNode.insertBefore(tx.content.cloneNode(true), ctas); tickMidnight(); }
    var tp = document.getElementById('sc-cart-pay');
    if (tp && ctas && !$('.sc-pay', ctas)) ctas.appendChild(tp.content.cloneNode(true));
    var btn = $('#CartDrawer-Checkout', d);
    if (btn && btn.textContent.indexOf('tranquila') < 0) btn.textContent = 'Sí, quiero ir tranquila →';
  }
  function initCart() {
    var d = $('cart-drawer'); if (!d) return;
    enhanceCart();
    var busy = false;
    new MutationObserver(function () { if (busy) return; busy = true; requestAnimationFrame(function () { enhanceCart(); busy = false; }); }).observe(d, { childList: true, subtree: true });
  }

  function init() { tickMidnight(); setInterval(tickMidnight, 1000); initEta(); initSliders(); initRails(); initModals(); initCalc(); initPdp(); initPopup(); initCart(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
})();
